import { useState, useEffect } from 'react'

export function useWindowWidth () {
  /*
    * Returns the viewport width using React Hooks
  */

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return width
}
